// @flow
export const APP_SERVICES_API = 'APP-RGS-API';
export const APP_SERVICES_ROUTER = 'APP-RGS-ROUTER';
export const APP_SERVICES_REST_API = 'APP-RGS-REST_API';
export const APP_SERVICES_RESOLVER = 'APP-RGS-RESOLVER';
export const APP_SERVICES_USER_PROFILE = 'APP-RGS-USER_PROFILE';

const SERVICES = {
	API: APP_SERVICES_API,
	ROUTER: APP_SERVICES_ROUTER,
	RESOLVER: APP_SERVICES_RESOLVER,
	REST_API: APP_SERVICES_REST_API,
	USER_PROFILE: APP_SERVICES_USER_PROFILE,
};

const APP_SERVICES = SERVICES;

export { SERVICES, APP_SERVICES };
